import {API} from '../../networking/http'
import {QueryMethod} from '../helpers/types'

export type GetInvoiceParams = undefined
export type GetInvoiceQueryParams = {
  transactionId: string
  docType: string
}
// eslint-disable-next-line
export type GetInvoiceQueryReturnType = any // TODO: add type
export type GetInvoiceQuery = QueryMethod<GetInvoiceParams, GetInvoiceQueryParams, GetInvoiceQueryReturnType>

export const serviceOptionsEndpoint = 'invoices/doc/download'

export const getInvoiceQuery: GetInvoiceQuery = ({query, ...rest}) => ({
  queryKey: ['GetInvoiceQuery', query],
  cacheTime: 1000 * 60,
  ...rest,
  queryFn: ({queryKey: [_, config]}) => {
    return API.get<GetInvoiceQueryParams, GetInvoiceQueryReturnType>(serviceOptionsEndpoint, {
      params: config,
      // eslint-disable-next-line
    }).then((res) => res.data)
  },
})
